import { FC, ReactNode } from "react";
import { Button, Col, Modal, Row, Typography } from "antd";
import {
  ButtonRow,
  GlobalModalStyles,
  StyledButton,
  StyledTag,
  Wrapper,
} from "./styled";
import { ConditionalTooltipText } from "../ConditionalTooltipText";
import { CloseIcon } from "../icons/CloseIcon";
import { EApproveStatus, TWDContractor } from "../../types";

interface IDocumentsModalProps {
  contractors: TWDContractor[];
  title: ReactNode;
  onCancel: () => void;
}

export const ContractorsModal: FC<IDocumentsModalProps> = ({
  contractors,
  title,
  onCancel,
}) => (
  <>
    <GlobalModalStyles />

    <Modal
      style={{ fontWeight: 600 }}
      className="contractors-modal"
      title={title}
      open={!!title}
      onCancel={onCancel}
      closeIcon={<CloseIcon />}
      footer={null}
    >
      {contractors?.length ? (
        <>
          <Wrapper maxHeight={window.innerHeight - 250}>
            {contractors.map((contractor) => (
              <Row align="middle" justify="space-between" key={contractor.id}>
                <Col span={10}>
                  <ConditionalTooltipText
                    text={contractor.shortName ?? contractor.name}
                    withoutBreaks
                  />
                </Col>

                <Col span={3}>
                  <StyledTag
                    color={
                      contractor.status === EApproveStatus.ACTUAL
                        ? "#51AD77"
                        : "#FAAD14"
                    }
                  >
                    {contractor.status === EApproveStatus.ACTUAL
                      ? "Принято"
                      : "Ожидание"}
                  </StyledTag>
                </Col>

                <Col span={3}>
                  {contractor.status === EApproveStatus.ACTUAL &&
                  contractor.acceptedAt ? (
                    <Typography.Text style={{ fontWeight: 400 }}>
                      {contractor.acceptedAt}
                    </Typography.Text>
                  ) : (
                    ""
                  )}
                </Col>

                <Col span={7}>
                  {contractor.status !== EApproveStatus.ACTUAL && (
                    <StyledButton type="link">
                      Отправить уведомление
                    </StyledButton>
                  )}
                </Col>
              </Row>
            ))}
          </Wrapper>

          {contractors.find(
            (contractor) => contractor.status !== EApproveStatus.ACTUAL
          ) && (
            <ButtonRow justify="end">
              <Button type="primary">Напомнить всем</Button>
            </ButtonRow>
          )}
        </>
      ) : (
        <Row justify="center">
          <Typography.Text strong>Список подрядчиков пуст</Typography.Text>
        </Row>
      )}
    </Modal>
  </>
);
